import { render, staticRenderFns } from "./a-svg-dots.vue?vue&type=template&id=04c1c3f3&scoped=true"
import script from "./a-svg-dots.vue?vue&type=script&lang=js"
export * from "./a-svg-dots.vue?vue&type=script&lang=js"
import style0 from "./a-svg-dots.vue?vue&type=style&index=0&id=04c1c3f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1c3f3",
  null
  
)

export default component.exports